import { Slide, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { GrFormCheckmark } from 'react-icons/gr';
import { IoMdClose } from 'react-icons/io';

import { Typography } from '@design-system';
import './showToast.scss';

export type showToastType = {
    type: 'success' | 'neutral' | 'error';
    message: string;
};

export const showToast = ({ type, message }: showToastType) => {
    toast(
        <div id="toast" style={{ display: 'flex', alignItems: 'center' }}>
            <div className={`icon-container ${type}`}>{type === 'success' ? <GrFormCheckmark /> : <IoMdClose />}</div>
            <Typography intrinsic="h1" variant="sub" className="toast-message">
                {message}
            </Typography>
        </div>,
        {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            draggable: true,
            theme: 'colored',
            transition: Slide,
            draggableDirection: 'y',
            draggablePercent: 100
        }
    );
};
